"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentDialogReducer = exports.setContentDialogState = void 0;
var toolkit_1 = require("@reduxjs/toolkit");
var initialState = {
    isOpen: false,
    header: "",
    width: "normal",
    closable: true,
    // content: "",
};
var modalSlice = (0, toolkit_1.createSlice)({
    name: "contentDialog",
    initialState: initialState,
    reducers: {
        setContentDialogState: function (state, action) {
            var _a = action.payload, isOpen = _a.isOpen, header = _a.header, width = _a.width, closable = _a.closable;
            state.isOpen = isOpen;
            state.header = header || "";
            state.width = width || "normal";
            state.closable = typeof closable === "boolean" ? closable : true;
            // state.content = content || "";
        },
    },
});
exports.setContentDialogState = modalSlice.actions.setContentDialogState;
exports.contentDialogReducer = modalSlice.reducer;
